import { render, staticRenderFns } from "./PostContent.vue?vue&type=template&id=1d473df8&scoped=true"
import script from "./PostContent.vue?vue&type=script&lang=js"
export * from "./PostContent.vue?vue&type=script&lang=js"
import style0 from "./PostContent.vue?vue&type=style&index=0&id=1d473df8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d473df8",
  null
  
)

export default component.exports